import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Header from "../components/header"
import Hero from "../components/hero"
import Contact from "../components/contact"
import Designer from "../components/designer"
import Gallery from "../components/gallery"
import Ready from "../components/ready"
import Terms from "../components/terms"
import Footer from "../components/footer"

const IndexPage = () => (
  <Layout>
    <SEO title="Business" />
    <Header />
    <Hero />
    <Designer />
    <Contact />
    <Gallery />
    <Ready />
    <Terms />
    <Footer />
  </Layout>
)

export default IndexPage
